module.exports = __webpack_public_path__ + "img/print-complete.fde5102e.png";